<template>
  <v-dialog
    v-model="dialogIsOpen"
    max-width="600"
    :persistent="true"
  >
    <v-card class="dialog-box home-form-container">
      <h2 class="form-title">{{ dialogTitle }}</h2>
      <div class="form-item mb-4">
        <label>{{ $t('LogicalType') }}</label>
        <treeselect
          class="tube-form-input-select"
          v-model="editedObjectData.logical_type"
          disableFuzzyMatching
          :options="fiberTypeOptions"
          :normalizer="listElementNormalizer"
        />
      </div>
      <div class="form-item">
        <label>{{ $tc('Comment', 1) }}</label>
        <textarea v-model="editedObjectData.comment" name="comment" id="comment" cols="30" rows="10" maxlength="1024"></textarea>
      </div>
      <div v-if="objectType==='tube'" class="warning-message-container">
        <span class="warning-message">*{{ $t('InsidePlanEditTubeWarning') }}</span>
      </div>

      <v-card-actions class="form-buttons" style="padding: 8px 0">
        <v-btn @click="$emit('close-form')" :ripple="false" class="secondary-button" text>
          {{ $t("Cancel") }}
        </v-btn>
        <v-btn @click="saveObject" :disabled="!saveButtonIsDisabled" :ripple="false" class="main-button" text>
          {{ $t("Edit") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import { listsMixin } from "@/mixins/listsMixin";

export default {
  name: "EditTubeFiberForm",

  components: {
    InputField
  },

  mixins: [ listsMixin ],

  props: {
    dialogIsOpen: {
      type: Boolean,
      required: true
    },
    itemToEdit: {
      type: Object
    },
    fiberTypeOptions: {
      type: Array,
      required: true,
    },
    objectData: {
      type: Object
    },
    objectType: {
      type: String,
    },
  },

  data() {
    return {
      editedObjectData: {
        comment: null,
        logical_type: null,
      },
    };
  },

  mounted() {
    this.editedObjectData.comment = this.objectData.comment ? this.objectData.comment : null;
    this.editedObjectData.logical_type = this.objectData.logical_type ? this.objectData.logical_type : null;
  },

  computed: {
    dialogTitle() {
      return this.objectType === "fiber" ? this.$i18n.t("EditFiber") : this.$i18n.t("EditTube");
    },

    saveButtonIsDisabled() {
      return this.editedObjectData.comment || this.editedObjectData.logical_type;
    }
  },

  methods: {
    saveObject() {
      this.$emit('edit-object', this.editedObjectData);
    },
  }
}
</script>

<style>
.tube-form-input-select .vue-treeselect__control {
  border: 1px solid black !important;
  border-radius: 8px !important;
}
</style>

<style scoped>
.form-item {
  width: 100%;
  padding-left: 5px;
  font-family: 'Lato', sans-serif;
  text-align: left;
  font-size: 12px;
}

.tube-form-input-select {
  margin-top: 5px;
}

.form-title {
  color: #42A1B6;
  text-align: start;
  padding-left: 5px;
  margin-bottom: 20px;
  font-weight: normal;
}

.tube-form-input-select .vue-treeselect__menu-container .vue-treeselect__menu {
  max-height: 90px !important;
}

.dialog-box {
  padding: 40px 45px;
  border-radius: 8px;
}

.v-dailog {
  padding: 8px 0;
}

textarea {
  border: 1px solid black !important;
  border-radius: 8px !important;
  height: 100px !important;
  margin-top: 5px;
}

.warning-message {
  font-size: 11px;
  color: #42A1B6;
  float: left;
  padding-left: 5px;
}

.warning-message-container {
  height: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/forms/EditTubeFiberForm.vue